import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { AddVehicleForm } from 'components';
import { getClientList } from 'store/clientSlice';
import { search_type } from 'utils';

export default function AddVehiclePage() {
	const [formData, setFormData] = useState({});
	const dispatch = useDispatch();
	const { id } = useParams();

	useEffect(() => {
		if (id) {
			dispatch(
				getClientList({
					search_type: search_type?.vehicle,
					filter_by: {
						id,
					},
				})
			).then((res) => {
				console.log('res', res);
				setFormData(res?.data?.[0]);
			});
		}
	}, [dispatch, id]);

	console.log('id', id);
	return <AddVehicleForm isEditMode={Boolean(formData?.id)} formData={formData} />;
}
